import { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

export function useSchoolName(schoolId) {
  const [schoolName, setSchoolName] = useState('');

  useEffect(() => {
    if (!schoolId) {
      setSchoolName('');
      return;
    }

    const loadSchool = async () => {
      try {
        const schoolDoc = await getDoc(doc(db, 'schools', schoolId));
        if (schoolDoc.exists()) {
          setSchoolName(schoolDoc.data().name || '');
        } else {
          setSchoolName('');
        }
      } catch (error) {
        console.error('Error loading school name:', error);
        setSchoolName('');
      }
    };

    loadSchool();
  }, [schoolId]);

  return schoolName;
}
